import { useSearchParams } from 'react-router-dom'
import { useState } from 'react'
import { graphql } from 'app/generated/gql'
import { gqlMutation } from 'app/lib/graphqlClient'
import type { Mutation } from 'app/generated/graphql'

// NOTE: Despite the name, resetPassword only SENDS the reset email.
// It does NOT change the password. The actual password change is done
// by the setPassword mutation (used in /reset page via useReset.ts).
const RESET_PASSWORD_MUTATION = graphql(`
  mutation ResetPassword($email: String!) {
    resetPassword(email: $email)
  }
`)

export type ForgotActionData = {
  success?: boolean
  error?: string
}

export type UseForgotReturn = {
  email: string
  success: boolean
  error: string | undefined
  isSubmitting: boolean
  setEmail: (email: string) => void
  onSubmit: (data?: { email: string }) => void
}

export function useForgot(): UseForgotReturn {
  const [searchParams] = useSearchParams()
  const [email, setEmail] = useState(decodeURIComponent(searchParams.get('email') || ''))
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState<string | undefined>()
  const [isSubmitting, setIsSubmitting] = useState(false)

  function onSubmit(data?: { email: string }) {
    const emailValue = data?.email || email
    if (!emailValue) return
    setIsSubmitting(true)
    setError(undefined)
    gqlMutation(RESET_PASSWORD_MUTATION, { email: emailValue })
      .then(({ error: gqlErr }) => {
        if (gqlErr) {
          setError(gqlErr.message)
        } else {
          setSuccess(true)
        }
      })
      .catch(() => setError('An unexpected error occurred'))
      .finally(() => setIsSubmitting(false))
  }

  return {
    email,
    success,
    error,
    isSubmitting,
    setEmail,
    onSubmit,
  }
}
